export default __webpack_public_path__ + "static/media/cfx-cm-spend.81ef6516.svg";